import React from "react";
import Image from "next/image";
import { AdditionalWrap, Content, Column, Text, Title, FeatureTitle } from "./styled";

const Additional = () => {
  return (
    <AdditionalWrap>
      <Title>Additional Features</Title>
      <Content>
        <Column>
          <Image src={`/images/additional1.png`} width={80} height={80} quality={100} />
          <FeatureTitle>Custom URL and QR Code</FeatureTitle>
          <Text>Create a custom URL and QR code so it's easy to tell customers where to find your recipes.</Text>
        </Column>
        <Column>
          <Image src={`/images/additional2.png`} quality={100} width={80} height={80} />
          <FeatureTitle>Re-engagement tools</FeatureTitle>
          <Text>
            Re-engage and notify your existing customers and fans of upcoming promotions, recipes, collections, and
            more.
          </Text>
          <Text textColor="GREY">(Coming Soon)</Text>
        </Column>
        <Column>
          <Image src={`/images/additional3.png`} quality={100} width={80} height={80} />
          <FeatureTitle>Transparent Analytics</FeatureTitle>
          <Text>Track your sales and engagement data in real time every day, week, month, and year.</Text>
          <Text textColor="GREY">(Coming Soon)</Text>
        </Column>
      </Content>
    </AdditionalWrap>
  );
};

export default Additional;
